<template>
  <el-breadcrumb separator="/">
    <div class="breadcrumb-content">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item
          class="breadcrumb-item"
          v-for="item in breadCrumbList"
          :key="item.path"
        >
          <span v-if="item.redirect === $route.path">
            {{ item.meta.title }}
          </span>
          <a v-else @click="handleLine(item)" style="color: grey">{{
            item.meta.title
          }}</a>
        </el-breadcrumb-item>
      </transition-group>
    </div>
  </el-breadcrumb>
</template>

<script>
export default {
  name: "BreadcrumbNav",
  data() {
    return {
      breadCrumbList: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.getBreadcrumbList();
      },
    },
  },
  methods: {
    getBreadcrumbList() {
      this.breadCrumbList = [];
      const matchedArray = this.$route.matched;
      matchedArray.shift();
      matchedArray.forEach((item) => {
        if (item.meta.title) this.breadCrumbList.push(item);
      });
      // 判断是否存在首页默认数据，不存在就插入到数据首位
      if (!this.breadCrumbList.length || this.breadCrumbList[0].name !== "home")
        this.breadCrumbList.unshift({
          path: "/",
          meta: { title: "首页" },
        });
    },
    handleLine({ redirect, path }) {
      redirect ? this.$router.push(redirect) : this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.el-breadcrumb {
  display: flex;
  padding-left: 5px;
  line-height: 50px;
}

.breadcrumb-item {
  margin-left: 2px;
}

.breadcrumb-content {
  position: relative;
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.5s;
}

.breadcrumb-enter-from,
.breadcrumb-leave-active {
  opacity: 0;
}

.breadcrumb-move {
  transition: all 0.5s;
}

.breadcrumb-leave-active {
  position: absolute;
  right: -200px;
}
</style>